export default __webpack_public_path__ + "static/media/pag6.23121676.jpg";